import { useCompanyCompare } from "../context/CompanyCompareContext";
import { useSubscription } from "../context/SubscriptionContext";

export default function CompanyCompareButton({ companyId, companyName }) {
  const { toggleCompanyCompare, isInCompanyCompareList, companyCompareList } = useCompanyCompare();
  const { isPro, setUpgradeMessage, setShowUpgradeModal } = useSubscription();

  const inList = isInCompanyCompareList(companyId);
  const full = companyCompareList.length >= 3 && !inList;

  function handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!isPro) {
      setUpgradeMessage("Comparing companies is a Pro feature. Upgrade to compare up to 3 companies side by side.");
      setShowUpgradeModal(true);
      return;
    }
    toggleCompanyCompare({ companyId, companyName });
  }

  return (
    <button
      onClick={handleClick}
      className={`text-xs px-3 py-1 rounded-lg border transition-all ${
        inList
          ? "bg-teal-500/20 border-teal-500/40 text-teal-300"
          : full
          ? "border-white/5 text-white/20 cursor-not-allowed"
          : "border-white/20 text-white/40 hover:border-teal-500/40 hover:text-teal-300"
      }`}
    >
      {inList ? "✓ Compare" : "+ Compare"}
    </button>
  );
}
